export const LetterheadDetailFragment = gql`
  fragment LetterheadDetailFragment on Letterhead {
    id
    name
    leftText
    rightText
    centerText
    centerFile {
      ...FileFragment
    }
  }
`
